// extracted by mini-css-extract-plugin
export default {"phone__wrapper":"legacy_phone__wrapper__O560v","phone__sub_message":"legacy_phone__sub_message__mxjbY","phone__error_message":"legacy_phone__error_message__r9lQM"};